import { render, staticRenderFns } from "./addliquidityDetail.vue?vue&type=template&id=27086d40&scoped=true"
import script from "./addliquidityDetail.vue?vue&type=script&lang=js"
export * from "./addliquidityDetail.vue?vue&type=script&lang=js"
import style0 from "./addliquidityDetail.vue?vue&type=style&index=0&id=27086d40&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27086d40",
  null
  
)

export default component.exports